export class InvalidFileError extends Error {}
export class EncryptionError extends Error {}
export class MissingSheetError extends Error {}
export class UnsupportedError extends Error {}
